import script from "./showValidateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./showValidateModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"showValidateModal.vue"]])

export default __exports__